import React, { useState, createContext } from 'react';

const RegisterDataContext = createContext();
export const RegisterDataProvider = ({ children }) => {
  const [totlePrice, setTotlePrice] = useState(0);
  const [posCount, setPosCount] = useState(0);
  const [DisabledId, setDisabledId] = useState(0);
  const [DisabledValue, setDisabledValue] = useState(0);
  const [activity_id, setActivity_id] = useState(0);
  const [packageId, setPackageId] = useState('');
  const [showOtp, setShowOtp] = useState(false);
  const [time, setTime] = useState(0);

  return (
    <RegisterDataContext.Provider
      value={{
        totlePrice,
        setTotlePrice,
        posCount,
        setPosCount,
        DisabledId,
        setDisabledId,
        DisabledValue,
        setDisabledValue,
        activity_id,
        setActivity_id,
        packageId,
        setPackageId,
        showOtp,
        setShowOtp,
        time,
        setTime
      }}>
      {children}
    </RegisterDataContext.Provider>
  );
};

export default RegisterDataContext;
